import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "hero-subsection",
  "aria-labelledby": "tarifs-hero-title"
}
const _hoisted_2 = { class: "hero-shell" }
const _hoisted_3 = { class: "hero-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", {
  id: "tarifs-hero-title",
  class: "hero-title"
}, "Des tarifs adaptés à vos besoins", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "hero-description" }, " Choisissez le plan Florisuite qui convient parfaitement à la taille et aux ambitions de votre commerce floral. Commencez votre essai gratuit dès aujourd'hui ! ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "hero-button-text" }, "Démarrer l'essai gratuit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: "hero-button",
          to: "/inscription"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}